/* 🤖 this file was generated by script */
export const wiconApprovePathStepBack = {
  name: 'approve_path_step_back',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 10a2 2 0 104 0 2 2 0 00-4 0zm0 0H7.92m0 0l2-2m-2 2l2 2M5 10a1 1 0 10-2 0 1 1 0 002 0z"/></svg>`,
};
